import styled from "styled-components";

import { transparentize } from "polished";

export const StyledCropper = styled.div`
    position: relative;
    font-family: inherit;
    text-align: left;

    .Label {
        font-weight: bold;
        font-size: 17px;
        margin: 5px 0;
    }

    .Link {
        margin: 8px 0;
    }

    canvas {
        background-color: ${p => p.theme.c.snow};
        cursor: move;
        display: block;
        margin: auto;
        margin-top: 12px;
    }
`;

export const Scaler = styled.div`
    width: 200px;
    height: 3px;
    background-color: ${p => p.theme.c.dark};
    margin: 32px auto;
    position: relative;
`;

export const ScalerDrag = styled.div`
    width: 32px;
    height: 32px;
    background-color: ${p => transparentize(1 - 0.7, p.theme.c.snow)};
    border-radius: 32px;
    position: absolute;
    left: 0%;
    margin-left: -16px;
    margin-top: -16px;
    border: 2px solid ${p => p.theme.c.dark};
    cursor: pointer;
`;

export const ModifyProfilePicture = styled.div`
    text-align: center;
    margin: 8px 0 12px;
    font-size: 18px;
`;

export const Rotate = styled.div`
    text-align: center;
    margin-top: 10px;
    margin-bottom: -4px;
    div {
        display: inline-block;
    }
`;
